import { Component, EventEmitter, OnInit, Output, ViewChild } from '@angular/core';
import { WizardModalComponent } from '@app/shared/components';
import { Batch } from '@app/shared/models/batch.model';
import { TranslateService } from '@ngx-translate/core';
import { SelectBatchesFormComponent } from './forms/select-batches-form/select-batches-form.component';
import { SelectSlotFormComponent } from './forms/select-slot-form/select-slot-form.component';


import { BatchService } from '@app/lift/service/batch.service';
import { ToastsManager } from "@app/shared/util/toastr.service";


@Component({
    selector: 'app-copy-batches-modal',
    templateUrl: './copy-batches-modal.component.html',
    styleUrls: ['./copy-batches-modal.component.scss']
})
export class CopyBatchesModalComponent implements OnInit {
    @ViewChild(WizardModalComponent, {static: false}) wizardModal: WizardModalComponent;
    @ViewChild(SelectBatchesFormComponent, {static: false}) selectBatchesForm: SelectBatchesFormComponent;
    @ViewChild(SelectSlotFormComponent, {static: false}) selectSlotForm: SelectSlotFormComponent;

    selectedStep: number;
    isLoading: boolean;
    availableBatches: Batch[] = [];
    selectedBatch: Batch;
    initialLiftId: number;
    initialTrayId: number;

    constructor(
        private translate: TranslateService,
        private toastr: ToastsManager,
        private batchService: BatchService,
    ) {
    }

    ngOnInit() {
    }

    onWizardCancel() {
        this.reset();
        this.wizardModal.close();
    }

    open(initialLiftId: number, initialTrayId: number, availableBatches: Batch[]) {
        this.availableBatches = availableBatches;
        if (this.selectBatchesForm) {
            this.selectBatchesForm.setBatches(availableBatches, []);
        }

        this.initialLiftId = initialLiftId;
        this.initialTrayId = initialTrayId;

        this.wizardModal.open();
    }

    close() {
        this.reset();
        this.wizardModal.close();
    }

    reset() {
        this.wizardModal.reset();
        this.selectBatchesForm.resetForm();
        this.selectSlotForm.reset();
    }

    onStepChange(stepIndex: number) {
        if (stepIndex === 1) {
            this.selectSlotForm.getLifts();
        }

        this.selectedStep = stepIndex;
    }

    onWizardSubmit() {
        const batches = this.selectBatchesForm.getFormValue.selectedBatches;
        const lift = this.selectSlotForm.getFormValue.lift;
        const tray = this.selectSlotForm.getFormValue.tray;
        const slot = this.selectSlotForm.getFormValue.slot;

        let hasErrors = false;
        if (batches.length === 0) {
            hasErrors = true;
            this.toastr.error(this.translate.instant('admin.lifts.notifications.noBatchesSelected'));
        }

        if (!slot) {
            hasErrors = true;
            this.toastr.error(this.translate.instant('admin.lifts.notifications.slotNotSelected'));
        }

        if (hasErrors) {
            return;
        }

        this.batchService.copyBatches(lift.id, tray.id, slot.id, batches.map(b => b.id)).subscribe({
            next: () => {
                this.toastr.success(this.translate.instant('admin.lifts.notifications.copiedBatchesSuccessfully'));
            },
            error: () => {
                this.toastr.error(this.translate.instant('admin.lifts.notifications.errorCopyingBatches'));
            }
        });

        this.close();
    }
}
